import FormErrorMessage from '@/app/common/components/FormErrorMessage'
import Label from '@/app/common/components/Label'
import FormSection from '@/common/components/FormSection.tsx'
import { SchoolFormValues } from '@/pages/providers/components/SchoolForm/schoolForm.schema.ts'
import { StateList } from '@/queries/common/requests.ts'
import type { Control, FieldErrors, UseFormWatch } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import { YesOrNoOptions } from '../../constants/constants'
import RadioButtonQuestion from '../form_elements/RadioButtonQuestion'

type Props = {
  control: Control<SchoolFormValues>
  watch: UseFormWatch<SchoolFormValues>
  states: StateList
  errors: FieldErrors<SchoolFormValues>
}

export default function BankingSection(props: Props) {
  const { control, errors } = props

  return (
    <div>
      <FormSection>
        <Label>ACH Information</Label>

        {/* Can receive ACH payment */}
        <Controller
          name="BankingSchema.canReceiveACH"
          control={control}
          render={({ field }) => (
            <RadioButtonQuestion
              question="Our School is able to receive funds via ACH payment"
              options={YesOrNoOptions}
              value={field.value}
              onChange={field.onChange}
            />
          )}
        />
        <FormErrorMessage
          message={errors?.BankingSchema?.canReceiveACH?.message}
        />
      </FormSection>
    </div>
  )
}
